<template>
  <div class="feedback-page">
    <div class="bg-decoration"></div>
    <div class="bg-decoration-2"></div>

    <div class="main-content">
      <!-- 未通过签名验证引导 -->
      <div v-if="!authVerified" class="no-access">
        <div v-if="authVerifying" class="no-access-card">
          <i class="el-icon-loading no-access-icon"></i>
          <p class="no-access-title">正在验证身份...</p>
        </div>
        <div v-else-if="authDeniedReason" class="no-access-card denied">
          <i class="el-icon-warning no-access-icon"></i>
          <p class="no-access-title">无法参与活动</p>
          <p class="no-access-desc">{{ authDeniedReason }}</p>
        </div>
        <div v-else class="no-access-card">
          <i class="el-icon-warning-outline no-access-icon"></i>
          <p class="no-access-title">请通过App内活动链接进入</p>
          <p class="no-access-desc">本活动页需在陌撩漂流瓶App内打开，方能识别您的身份并参与反馈有奖活动。</p>
        </div>
      </div>

      <template v-else>
        <!-- 顶部返回 + 品牌 -->
        <div class="top-bar">
          <span class="back-btn" @click="goBack"><i class="el-icon-arrow-left"></i> 活动中心</span>
          <span class="brand-name">陌撩漂流瓶</span>
        </div>

        <!-- 主视觉 Hero -->
        <div class="hero-card">
          <div class="hero-badge"><span class="dot"></span>问题反馈有奖</div>
          <h1 class="hero-title">反馈问题 赢取奖励</h1>
          <div class="hero-amount">最高 <span class="num">50</span><span class="unit">元</span></div>
          <p class="hero-desc">提交APP中遇到的真实功能问题，经审核采纳即可获得 <b>5-50元</b> 现金奖励。</p>
        </div>

        <!-- 奖励规则 -->
        <div class="rules-card">
          <div class="card-title"><i class="el-icon-document-checked"></i><span>奖励规则</span></div>
          <ol class="rules-list">
            <li>在App内或本页面提交真实有效的问题反馈。</li>
            <li>反馈经工作人员审核，判定为有效问题即获奖励：</li>
            <div class="sub">· 轻微体验问题：<b>2元</b></div>
            <div class="sub">· 一般功能问题：<b>10元</b></div>
            <div class="sub">· 严重功能问题：<b>20元</b></div>
            <div class="sub">· 致命功能问题：<b>50元</b></div>
            <li>同一问题以首次提交者为准，重复提交不予奖励。</li>
            <li>审核时间较长, 在3-7个工作日。期间请耐心等待。</li>
            <li>奖励将在审核采纳后,直接转账至最近一次成功提现的用户 支付宝账户，无需手动领取，请确保支付宝账户信息正确。</li>
          </ol>
        </div>

        <!-- 功能区 Tabs -->
        <div class="panel-card">
          <el-tabs v-model="activeTab" class="feedback-tabs" @tab-click="onTabClick">
            <!-- 提交反馈 -->
            <el-tab-pane label="提交反馈" name="submit">
              <div class="feedback-form">
                <div class="form-item">
                  <label class="form-label">问题类型 <em>*</em></label>
                  <el-select v-model="form.type" placeholder="请选择问题类型" :disabled="submitSuccess" class="full-select">
                    <el-option v-for="o in typeOptions" :key="o.value" :label="o.label" :value="o.value"></el-option>
                  </el-select>
                </div>

                <div class="form-item">
                  <label class="form-label">问题描述 <em>*</em></label>
                  <el-input
                    v-model="form.content"
                    type="textarea"
                    :rows="5"
                    maxlength="500"
                    show-word-limit
                    resize="none"
                    placeholder="请详细描述遇到的问题，包括操作步骤、出现场景等，便于我们定位"
                    :disabled="submitSuccess"
                  ></el-input>
                </div>

                <!-- <div class="form-item">
                  <label class="form-label">问题截图 <span class="optional">(选填，最多6张)</span></label>
                  <el-upload
                    action="#"
                    list-type="picture-card"
                    :auto-upload="true"
                    :http-request="handleUploadImage"
                    :file-list="imageFileList"
                    :limit="6"
                    :before-upload="beforeImageUpload"
                    :on-remove="handleRemoveImage"
                    :on-exceed="handleExceed"
                    :disabled="submitSuccess"
                    accept="image/jpeg,image/png,image/gif,image/webp,image/bmp"
                    :class="{ 'hide-upload': imageFileList.length >= 6 }"
                    class="feedback-uploader"
                  >
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">支持 jpg/png/gif/webp/bmp 格式，单张不超过 5MB</div>
                  </el-upload>
                </div> -->

                <div class="form-item">
                  <label class="form-label">联系方式 <span class="optional">(选填)</span></label>
                  <el-input v-model="form.contact" maxlength="20" placeholder="手机号/微信号，便于发放奖励" :disabled="submitSuccess">
                    <i slot="prefix" class="el-input__icon el-icon-user"></i>
                  </el-input>
                </div>

                <el-button type="primary" class="submit-btn" :loading="submitting" :disabled="submitSuccess" @click="submitFeedback">
                  {{ submitSuccess ? '已提交' : '提交反馈' }}
                </el-button>

                <p class="form-tip">提交后可在「我的记录」中查看审核进度与奖励发放情况</p>

                <div v-if="submitSuccess" class="submit-result">
                  <div class="result-title"><i class="el-icon-success"></i>提交成功</div>
                  <div class="result-detail">
                    <div class="result-row"><span>反馈编号</span><b>{{ submitResult && submitResult.id }}</b></div>
                    <div class="result-row"><span>提交时间</span><b>{{ submitResult && formatTime(submitResult.created_at) }}</b></div>
                    <div class="result-row"><span>当前状态</span><b class="pending">审核中</b></div>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <!-- 我的记录 -->
            <el-tab-pane :label="`我的记录${recordsTotal ? ' (' + recordsTotal + ')' : ''}`" name="records">
              <div class="records-filter">
                <el-radio-group v-model="recordsFilter" size="mini" @change="onRecordsFilterChange">
                  <el-radio-button label="">全部</el-radio-button>
                  <el-radio-button label="0">审核中</el-radio-button>
                  <el-radio-button label="1">已奖励</el-radio-button>
                  <el-radio-button label="2">未采纳</el-radio-button>
                </el-radio-group>
              </div>

              <div v-loading="recordsLoading" class="list-wrap">
                <div v-if="records.length" class="record-list">
                  <div v-for="item in records" :key="item.id" class="record-card">
                    <div class="record-head">
                      <el-tag size="mini" :type="typeTagType(item.type)" effect="light">{{ typeText(item.type) }}</el-tag>
                      <el-tag size="mini" :type="recordStatusType(item.status)" effect="plain">{{ recordStatusText(item.status) }}</el-tag>
                    </div>
                    <div class="record-content">{{ item.content }}</div>
                    <div class="record-foot">
                      <span class="foot-time">{{ formatTime(item.created_at) }}</span>
                      <span v-if="item.status === 1 && item.reward && item.reward > 0" class="foot-reward">
                        奖励 ¥{{ Number(item.reward).toFixed(2) }}
                      </span>
                    </div>
                  </div>
                </div>
                <el-empty v-else-if="!recordsLoading" description="暂无反馈记录" :image-size="100"></el-empty>
              </div>

              <div v-if="recordsTotal > recordsPageSize" class="pager">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="recordsPage"
                  :page-size="recordsPageSize"
                  :total="recordsTotal"
                  small
                  @current-change="onPageChange"
                ></el-pagination>
              </div>
            </el-tab-pane>

            <!-- 全部记录（脱敏展示，防止重复提交纠纷） -->
            <el-tab-pane :label="`全部记录${allRecordsTotal ? ' (' + allRecordsTotal + ')' : ''}`" name="allRecords">
              <div class="all-records-tip">
                <i class="el-icon-info"></i>
                <span>此处展示所有用户的反馈记录，为保护隐私与防止纠纷，用户ID与联系方式已隐藏，问题描述仅展示部分内容。</span>
              </div>

              <div class="all-records-filter">
                <el-radio-group v-model="allRecordsFilter" size="mini" @change="onAllRecordsFilterChange">
                  <el-radio-button label="">全部</el-radio-button>
                  <el-radio-button label="0">审核中</el-radio-button>
                  <el-radio-button label="1">已奖励</el-radio-button>
                </el-radio-group>
              </div>

              <div v-loading="allRecordsLoading" class="list-wrap">
                <div v-if="allRecords.length" class="record-list">
                  <div v-for="item in allRecords" :key="item.id" class="record-card public-card">
                    <div class="record-head">
                      <el-tag size="mini" :type="typeTagType(item.type)" effect="light">{{ typeText(item.type) }}</el-tag>
                      <el-tag size="mini" :type="recordStatusType(item.status)" effect="plain">{{ recordStatusText(item.status) }}</el-tag>
                    </div>
                    <div class="record-content">{{ item.content_preview }}</div>
                    <div class="record-foot">
                      <span class="foot-time">{{ formatTime(item.created_at) }}</span>
                      <span v-if="item.status === 1 && item.reward && item.reward > 0" class="foot-reward">
                        奖励 ¥{{ Number(item.reward).toFixed(2) }}
                      </span>
                    </div>
                  </div>
                </div>
                <el-empty v-else-if="!allRecordsLoading" description="暂无反馈记录" :image-size="100"></el-empty>
              </div>

              <div v-if="allRecordsTotal > allRecordsPageSize" class="pager">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="allRecordsPage"
                  :page-size="allRecordsPageSize"
                  :total="allRecordsTotal"
                  small
                  @current-change="onAllRecordsPageChange"
                ></el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div class="bottom-bar">© 2026 陌撩漂流瓶</div>
      </template>
    </div>
  </div>
</template>

<script>
import { FeedbackSubmitApi, FeedbackRecordsApi, FeedbackAllRecordsApi, FeedbackUploadImageApi, VerifySignatureApi } from '@/api/api.js'
import { setToken } from '@/utils/dataStorage.js'
import { setAuthParams, buildAuthQuery, isAuthParamsComplete } from '@/utils/authParams.js'

export default {
  name: 'FeedbackActivity',
  data() {
    return {
      userId: '',
      authVerified: false,
      authVerifying: true,
      authDeniedReason: '',
      token: '',
      activeTab: 'submit',
      // 表单
      form: {
        type: 'bug',
        content: '',
        contact: ''
      },
      // 图片上传
      imageFileList: [],
      uploadedImages: [],
      typeOptions: [
        { value: 'bug', label: '功能Bug' },
        // { value: 'experience', label: '体验问题' },
        // { value: 'content', label: '内容问题' },
        // { value: 'other', label: '其他建议' }
      ],
      submitting: false,
      submitSuccess: false,
      submitResult: null,
      // 我的记录
      records: [],
      recordsTotal: 0,
      recordsPage: 1,
      recordsPageSize: 10,
      recordsLoading: false,
      recordsFilter: '0',
      // 全部记录（脱敏）
      allRecords: [],
      allRecordsTotal: 0,
      allRecordsPage: 1,
      allRecordsPageSize: 10,
      allRecordsLoading: false,
      allRecordsFilter: '1'
    }
  },
  mounted() {
    const query = this.$route.query || {};
    if (query.token) {
      this.token = query.token;
      setToken(query.token);
    }
    // 参数完整性检查：签名参数齐全才请求后端验证签名
    if (isAuthParamsComplete(query)) {
      setAuthParams(query);
      VerifySignatureApi().then(res => {
          if (res && res.code === 200 && res.data && res.data.user_id) {
            this.userId = String(res.data.user_id);
            this.authVerified = true;
            this.fetchRecords();
          } else {
            this.authVerified = false;
          }
        }).catch(err => {
          // 提取 403 业务限制原因（性别限制/黑名单等），显示友好的限制提示卡片
          const detail = err && err.response && err.response.data && err.response.data.detail;
          if (detail) {
            this.authDeniedReason = detail;
          }
          this.authVerified = false;
        }).finally(() => {
        this.authVerifying = false;
      });
    } else {
      // 参数不全，直接拒绝
      this.authVerified = false;
      this.authVerifying = false;
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/activity/list', query: buildAuthQuery(this.$route.query) });
    },
    // tab 切换：每次点击都重新拉取数据
    onTabClick(tab) {
      if (tab.name === 'records') {
        this.recordsPage = 1;
        this.fetchRecords();
      } else if (tab.name === 'allRecords') {
        this.allRecordsPage = 1;
        this.fetchAllRecords();
      }
    },
    // 提交反馈
    submitFeedback() {
      if (!this.form.type) {
        this.$message.warning('请选择问题类型');
        return;
      }
      const content = (this.form.content || '').trim();
      if (!content) {
        this.$message.warning('请填写问题描述');
        return;
      }
      if (content.length < 10) {
        this.$message.warning('描述过短，请至少填写10个字');
        return;
      }
      this.submitting = true;
      FeedbackSubmitApi({
        type: this.form.type,
        content: content,
        contact: (this.form.contact || '').trim(),
        images: this.uploadedImages
      }).then(data => {
        this.submitSuccess = true;
        this.submitResult = data;
        this.$message.success('提交成功，感谢您的反馈');
        // 清空图片列表
        this.imageFileList = [];
        this.uploadedImages = [];
      }).catch(() => {}).finally(() => {
        this.submitting = false;
      });
    },
    // 图片上传前校验
    beforeImageUpload(file) {
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'];
      if (allowedTypes.indexOf(file.type) === -1) {
        this.$message.error('仅支持 jpg/png/gif/webp/bmp 格式图片');
        return false;
      }
      if (file.size / 1024 / 1024 >= 5) {
        this.$message.error('图片大小不能超过 5MB');
        return false;
      }
      return true;
    },
    // 自定义图片上传：调用后端 /v2/feedback_upload_image
    handleUploadImage(options) {
      const formData = new FormData();
      formData.append('file', options.file);
      FeedbackUploadImageApi(formData).then(data => {
        if (data && data.url) {
          this.uploadedImages.push(data.url);
          // 设置 file.url 供 picture-card 显示缩略图，并供 remove 时定位
          options.file.url = data.url;
          if (typeof options.onSuccess === 'function') {
            options.onSuccess(data);
          }
          this.$message.success('图片上传成功');
        } else {
          if (typeof options.onError === 'function') {
            options.onError(new Error('上传响应异常'));
          }
          this.$message.error('图片上传失败');
        }
      }).catch(err => {
        if (typeof options.onError === 'function') {
          options.onError(err);
        }
        // 提取后端 429 频率限制等业务错误的具体原因
        var detail = err && err.response && err.response.data && err.response.data.detail;
        if (detail) {
          this.$message.error(detail);
        } else {
          this.$message.error('图片上传失败，请重试');
        }
      });
    },
    // 从 imageFileList 中移除指定文件
    removeFileFromList(file) {
      const idx = this.imageFileList.findIndex(f => f.uid === file.uid);
      if (idx !== -1) {
        this.imageFileList.splice(idx, 1);
      }
    },
    // 移除图片
    handleRemoveImage(file) {
      const url = file.url || (file.response && file.response.url);
      if (url) {
        const idx = this.uploadedImages.indexOf(url);
        if (idx !== -1) {
          this.uploadedImages.splice(idx, 1);
        }
      }
      // 同步 imageFileList
      this.removeFileFromList(file);
    },
    // 超出数量限制
    handleExceed() {
      this.$message.warning('最多上传 6 张图片');
    },
    // 拉取我的记录
    fetchRecords() {
      this.recordsLoading = true;
      const params = {
        page: this.recordsPage,
        page_size: this.recordsPageSize
      };
      if (this.recordsFilter !== '') {
        params.status = Number(this.recordsFilter);
      }
      FeedbackRecordsApi(params).then(res => {
        if (res && res.code === 200) {
          this.records = res.data || [];
          this.recordsTotal = res.count || 0;
        } else if (res) {
          this.$message.error(res.msg || '获取记录失败');
        }
      }).catch(() => {
        this.$message.error('网络异常，请稍后重试');
      }).finally(() => {
        this.recordsLoading = false;
      });
    },
    onPageChange(p) {
      this.recordsPage = p;
      this.fetchRecords();
    },
    onRecordsFilterChange() {
      this.recordsPage = 1;
      this.fetchRecords();
    },
    // 拉取全部记录（脱敏）
    fetchAllRecords() {
      this.allRecordsLoading = true;
      const params = {
        page: this.allRecordsPage,
        page_size: this.allRecordsPageSize
      };
      if (this.allRecordsFilter !== '') {
        params.status = Number(this.allRecordsFilter);
      }
      FeedbackAllRecordsApi(params).then(res => {
        if (res && res.code === 200) {
          this.allRecords = res.data || [];
          this.allRecordsTotal = res.count || 0;
        } else if (res) {
          this.$message.error(res.msg || '获取记录失败');
        }
      }).catch(() => {
        this.$message.error('网络异常，请稍后重试');
      }).finally(() => {
        this.allRecordsLoading = false;
      });
    },
    onAllRecordsPageChange(p) {
      this.allRecordsPage = p;
      this.fetchAllRecords();
    },
    onAllRecordsFilterChange() {
      this.allRecordsPage = 1;
      this.fetchAllRecords();
    },
    typeText(type) {
      const map = { bug: '功能Bug', experience: '体验问题', content: '内容问题', other: '其他建议' };
      return map[type] || '其他';
    },
    typeTagType(type) {
      const map = { bug: 'danger', experience: 'warning', content: 'success', other: 'info' };
      return map[type] || 'info';
    },
    recordStatusText(status) {
      if (status === 0) return '审核中';
      if (status === 1) return '已奖励';
      return '未采纳';
    },
    recordStatusType(status) {
      if (status === 0) return 'warning';
      if (status === 1) return 'success';
      return 'info';
    },
    // 时间戳转 YYYY-MM-DD HH:MM:SS
    formatTime(timestamp) {
      if (!timestamp) return '';
      const d = new Date(typeof timestamp === 'number' ? timestamp * 1000 : timestamp);
      if (isNaN(d.getTime())) return String(timestamp);
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    }
  }
}
</script>

<style scoped>
.feedback-page {
  min-height: 100vh;
  background: linear-gradient(160deg, #f5f3ff 0%, #fff9ff 40%, #fdf2f8 100%);
  position: relative;
  overflow: hidden;
}

.bg-decoration {
  position: absolute;
  top: -160px;
  right: -160px;
  width: 420px;
  height: 420px;
  background: radial-gradient(circle, rgba(168, 85, 247, 0.18) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.bg-decoration-2 {
  position: absolute;
  bottom: -120px;
  left: -120px;
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.12) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 8s ease-in-out infinite reverse;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(20px, 20px) scale(1.08); }
}

.main-content {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 18px 18px 40px;
  position: relative;
  z-index: 1;
}

/* 顶部栏 */
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.back-btn {
  font-size: 14px;
  color: #a855f7;
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.back-btn i {
  margin-right: 4px;
}
.brand-name {
  font-size: 14px;
  font-weight: 700;
  background: linear-gradient(135deg, #a855f7 0%, #6366f1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 未授权 */
.no-access-card {
  background: #fff;
  border-radius: 24px;
  padding: 56px 28px;
  text-align: center;
  box-shadow: 0 12px 40px rgba(168, 85, 247, 0.12);
  margin-top: 80px;
}
.no-access-card.denied {
  border: 1px solid #fde2e2;
  background: linear-gradient(135deg, #fff5f5 0%, #f5f0ff 100%);
}
.no-access-card.denied .no-access-icon {
  color: #f56c6c;
}
.no-access-icon {
  font-size: 52px;
  color: #a855f7;
  margin-bottom: 16px;
  display: block;
}
.no-access-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}
.no-access-desc {
  font-size: 14px;
  color: #999;
  line-height: 1.7;
}

/* Hero */
.hero-card {
  background: linear-gradient(135deg, #a855f7 0%, #6366f1 100%);
  border-radius: 26px;
  padding: 28px 24px 24px;
  color: #fff;
  text-align: center;
  box-shadow: 0 16px 44px rgba(168, 85, 247, 0.35);
  position: relative;
  overflow: hidden;
  margin-bottom: 16px;
}
.hero-card::after {
  content: '';
  position: absolute;
  top: -40px;
  right: -40px;
  width: 160px;
  height: 160px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.18) 0%, transparent 70%);
  border-radius: 50%;
}
.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.22);
  padding: 5px 14px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 14px;
}
.hero-badge .dot {
  width: 6px;
  height: 6px;
  background: #fff;
  border-radius: 50%;
  animation: blink 1.4s ease-in-out infinite;
}
@keyframes blink {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
}
.hero-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
  letter-spacing: 1px;
}
.hero-amount {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}
.hero-amount .num {
  font-size: 52px;
  font-weight: 800;
  line-height: 1;
  vertical-align: -6px;
  margin: 0 2px;
  text-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}
.hero-amount .unit {
  font-size: 24px;
  font-weight: 800;
}
.hero-desc {
  font-size: 13px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.92);
}
.hero-desc b {
  font-weight: 700;
}

/* 规则卡 / 面板卡 */
.rules-card,
.panel-card {
  background: #fff;
  border-radius: 22px;
  padding: 20px 18px;
  box-shadow: 0 8px 28px rgba(168, 85, 247, 0.1);
  margin-bottom: 16px;
  border: 1px solid rgba(168, 85, 247, 0.06);
}
.card-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 14px;
}
.card-title i {
  color: #a855f7;
  margin-right: 8px;
  font-size: 18px;
}
.rules-list {
  margin: 0;
  padding-left: 18px;
  color: #666;
  font-size: 13px;
  line-height: 1.9;
}
.rules-list li {
  margin-bottom: 2px;
}
.rules-list li.sub {
  list-style: none;
  margin-left: 8px;
  color: #888;
}
.rules-list b {
  color: #a855f7;
}

/* Tabs */
.feedback-tabs >>> .el-tabs__item {
  font-size: 15px;
  font-weight: 600;
  color: #888;
}
.feedback-tabs >>> .el-tabs__item.is-active {
  color: #a855f7;
}
.feedback-tabs >>> .el-tabs__active-bar {
  background-color: #a855f7;
}
.feedback-tabs >>> .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #ede3f5;
}

/* 表单 */
.feedback-form {
  padding-top: 8px;
}
.form-item {
  margin-bottom: 18px;
}
.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}
.form-label em {
  color: #f56c6c;
  font-style: normal;
  margin-left: 2px;
}
.form-label .optional {
  color: #bbb;
  font-weight: 400;
  font-size: 12px;
}
.full-select {
  width: 100%;
}
.feedback-form >>> .el-input__inner,
.feedback-form >>> .el-textarea__inner {
  border-radius: 12px;
  border-color: #e8dcf0;
}
.feedback-form >>> .el-input__inner:focus,
.feedback-form >>> .el-textarea__inner:focus,
.feedback-form >>> .el-select .el-input__inner:focus {
  border-color: #a855f7;
}
.feedback-form >>> .el-textarea__inner {
  font-size: 14px;
  line-height: 1.6;
}

/* 图片上传 */
.hide-upload >>> .el-upload--picture-card {
  display: none;
}
.feedback-uploader >>> .el-upload--picture-card {
  width: 90px;
  height: 90px;
  border-radius: 12px;
  border: 1px dashed #d9b8e8;
  background: #faf5ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.feedback-uploader >>> .el-upload--picture-card i {
  color: #c084fc;
  font-size: 24px;
}
.feedback-uploader >>> .el-upload-list--picture-card .el-upload-list__item {
  width: 90px;
  height: 90px;
  border-radius: 12px;
}
.feedback-uploader >>> .el-upload__tip {
  font-size: 12px;
  color: #999;
  margin-top: 6px;
  line-height: 1.4;
}

.submit-btn {
  width: 100%;
  height: 48px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #a855f7 0%, #6366f1 100%);
  border: none;
  box-shadow: 0 8px 20px rgba(168, 85, 247, 0.35);
}
.submit-btn:disabled {
  opacity: 0.6;
}
.form-tip {
  margin-top: 14px;
  font-size: 12px;
  color: #aaa;
  text-align: center;
}
.submit-result {
  margin-top: 18px;
  border-radius: 14px;
  padding: 14px 16px;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
}
.result-title {
  font-size: 14px;
  font-weight: 700;
  color: #67c23a;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.result-title i {
  margin-right: 6px;
  font-size: 16px;
}
.result-detail {
  margin-top: 6px;
}
.result-row {
  position: relative;
  font-size: 13px;
  padding: 3px 0;
}
.result-row span {
  color: #888;
}
.result-row b {
  color: #333;
  position: absolute;
  right: 0;
  top: 3px;
}
.result-row b.pending {
  color: #e6a23c;
}

/* 记录列表 */
.list-wrap {
  min-height: 120px;
}
.record-card {
  background: #faf8ff;
  border: 1px solid #efe6f5;
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 12px;
}
/* 全部记录卡片样式（脱敏，与我的记录区分） */
.record-card.public-card {
  background: #f6faff;
  border-color: #e0ecf5;
}

/* 全部记录顶部提示 */
.all-records-tip {
  display: flex;
  align-items: flex-start;
  background: #fff8e6;
  border: 1px solid #ffe7b3;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  color: #b88500;
  line-height: 1.6;
  margin-bottom: 12px;
}
.all-records-tip i {
  color: #f0a020;
  margin-right: 6px;
  font-size: 14px;
  margin-top: 2px;
  flex-shrink: 0;
}

/* 筛选栏（我的记录 / 全部记录通用） */
.records-filter,
.all-records-filter {
  margin-bottom: 12px;
}
.records-filter >>> .el-radio-button__inner,
.all-records-filter >>> .el-radio-button__inner {
  border-color: #e8dcf0;
  color: #888;
}
.records-filter >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner,
.all-records-filter >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #f3e8ff;
  border-color: #d8b4fe;
  color: #7e22ce;
  box-shadow: -1px 0 0 0 #d8b4fe;
}
.record-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.record-content {
  font-size: 13px;
  color: #555;
  line-height: 1.7;
  word-break: break-all;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.record-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  border-top: 1px dashed #e8dcf0;
  padding-top: 10px;
}
.foot-time {
  color: #bbb;
  text-align: left;
}
.foot-reward {
  color: #a855f7;
  font-weight: 700;
}

.pager {
  margin-top: 18px;
  text-align: center;
}
.pager >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #a855f7;
}
.pager >>> .el-pagination.is-background .btn-prev,
.pager >>> .el-pagination.is-background .btn-next,
.pager >>> .el-pagination.is-background .el-pager li {
  background-color: #fff;
}

.bottom-bar {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin-top: 24px;
}

@media (min-width: 481px) {
  .main-content {
    padding: 28px 18px 48px;
  }
}

@media (max-width: 360px) {
  .hero-amount .num {
    font-size: 44px;
  }
  .hero-title {
    font-size: 20px;
  }
  .record-content {
    font-size: 12px;
  }
}
</style>
